import styled from "vue-styled-components";

export const BreadcrumbProps = {
  backgroundColor: {
    type: String,
    default: "#ffffff"
  }
};

export const SWrapper = styled("div", BreadcrumbProps)`
  width: 100%;
  padding: 16px 0;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const SNavigation = styled.nav`
  width: 100%;
`;

export const SNavigationItems = styled.ol`
  margin: 0;
  padding: 12px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 140%;
  list-style: none;
`;

export const SNavigationItem = styled.li`
  font-family: ${({ theme }) => theme.font.family.inter};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.md};
  color: ${({ theme }) => theme.colors.neutral.gray8};
  text-decoration: none;

  &:not(:first-child)::before {
    content: url(${require("../../assets/images/breadcrumb-chevron-right.svg")});
    float: left;
    padding: 0 10px;
    color: ${({ theme }) => theme.colors.neutral.gray8};
  }

  a {
    color: ${({ theme }) => theme.colors.neutral.gray8};
    text-decoration: none;

    &:hover,
    &:active {
      text-decoration: underline !important;
    }
  }
`;

export const SNavigationText = styled.span`
  font-family: ${({ theme }) => theme.font.family.inter};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  font-size: ${({ theme }) => theme.font.size.md};
  color: ${({ theme }) => theme.colors.neutral.gray5};
  line-height: 140%;
`;
